import { SubpropertyService } from '@modules/subproperty/subproperty-service';

import ManageEnum from '@shared/manage/manage-enum';
import ManageModel from '@shared/manage/manage-model';
import { get } from 'lodash';

import ProgressBar from '@shared/progress-bar/progress-bar';

export default {
  namespaced: true,

  state: {
    maxManage: { type: null },
    currentManage: { type: null },
    currentManageLoading: false,
    canGoBack: false,
    isMonoSubproperty: false
  },

  getters: {
    maxManage: (state) => state.maxManage,
    currentManage: (state) => state.currentManage,
    currentManageLoading: (state) => state.currentManageLoading,
    paymentsEnabled: (state) => {
      const { currentManage } = state;

      if (!currentManage) return false;

      if (currentManage.type === 'property') {
        if (!('property' in currentManage)) return false;
        if (!('walletEnabled' in currentManage.property)) return false;
        return currentManage.property.walletEnabled;
      }

      if (currentManage.type === 'subproperty') {
        if (!('subproperty' in currentManage)) return false;
        if (!('paymentsEnabled' in currentManage.subproperty)) return false;
        return currentManage.subproperty.paymentsEnabled;
      }
    },
    canGoBack: (state) => {
      return state.currentManage && state.currentManage.type && state.maxManage && state.maxManage.type && state.currentManage.type !== state.maxManage.type;
    },
    isMonoSubproperty: (state) => {
      return state.currentManage.property && state.currentManage.property.maxNumSubproperty && state.currentManage.property.maxNumSubproperty == 1
    },
    isPropertyNBA: (state) => get(state, 'currentManage.property.type', null) === 'nba',
    typeDatePicker: (state) => {
      const birthdateType =  get(state, 'currentManage.subproperty.birthdateType', null);

      const mapToDatePickerType = {
        'year': 'year',
        'monthAndYear': 'month'
      }
      
      return get(mapToDatePickerType, birthdateType, 'year');
    },
    populateDate: (state) => {
      const birthdateType =  get(state, 'currentManage.subproperty.birthdateType', null);

      const mapToPopulateDate = {
        'year': { year: true, month: false, day: false },
        'monthAndYear': { year: true, month: true, day: false }
      }

      return get(mapToPopulateDate, birthdateType, { year: true, month: true, day: true});
    },
    dateFormat: (state) => get(state, 'currentManage.subproperty.dateFormat', 'MM/dd/yyyy'),
    timeFormat: (state) => get(state, 'currentManage.subproperty.timeFormat', 'HH:mm'),
    propertyId: (state) => get(state, 'currentManage.property.id', null),
    subpropertyId: (state) => get(state, 'currentManage.subproperty.id', null),
    connectedAccountId: (state) => get(state, 'currentManage.subproperty.connectedAccountId', null),
  },

  mutations: {
    SET_MAX_MANAGE(state, payload = null) {
      state.maxManage = payload;
    },

    SET_CURRENT_MANAGE(state, payload = null) {
      state.currentManage = payload;
      localStorage.setItem('currentManage', JSON.stringify(payload));
    },

    SET_CURRENT_MANAGE_LOADING(state, payload = true) {
      state.currentManageLoading = !!payload;
    },
  },

  actions: {
    async doUpdateManage({ commit, rootGetters }, { manage } = {}) {
      const localCurrentManage = JSON.parse(localStorage.getItem('currentManage') || null);
      let currentManage = manage;

      const thisManage = (() => {
        if (currentManage) return currentManage
        if (rootGetters['auth/manage/currentManage'].type) return rootGetters['auth/manage/currentManage']
        return localCurrentManage
      })();

      currentManage = new ManageModel(thisManage);
      commit('SET_CURRENT_MANAGE_LOADING', true);

      await currentManage.loadData();

      if (Object.keys(currentManage).length) commit('SET_CURRENT_MANAGE', currentManage);
      commit('SET_CURRENT_MANAGE_LOADING', false);
    },

    async doChangeMaxManage({ commit, rootGetters }) {
      const currentUser = rootGetters['auth/currentUser'];
      if (!currentUser) return;

      commit('SET_MAX_MANAGE', currentUser.maxManage ? currentUser.maxManage : { type: null });
    },
    
    async doChangeManage({
      commit,
      dispatch,
      rootGetters
    }, {
      manage,
      doNavigation = true,
      forceFetch = false,
      initMenu = true
    } = {}) {
      const localCurrentManage = JSON.parse(localStorage.getItem('currentManage') || null);
      let currentManage = manage;

      if (forceFetch) {
        const manage = (() => {
          if (currentManage) return currentManage
          if (rootGetters['auth/manage/currentManage'].type) return rootGetters['auth/manage/currentManage']
          return localCurrentManage
        })()
        currentManage = new ManageModel(manage);
        commit('SET_CURRENT_MANAGE_LOADING', true);
        await currentManage.loadData();
        commit('SET_CURRENT_MANAGE_LOADING', false);
      } else if (!manage) {
        if (!!localCurrentManage && typeof localCurrentManage === 'object') {
          currentManage = localCurrentManage;
        } else {
          currentManage = new ManageModel(rootGetters['auth/manage/maxManage']);
          commit('SET_CURRENT_MANAGE_LOADING', true);
          await currentManage.loadData();
          commit('SET_CURRENT_MANAGE_LOADING', false);
        }
      }

      if (currentManage.type === 'property') {
        currentManage.subproperty = {}
        currentManage.subpropertyId = null
      }

      if (Object.keys(currentManage).length) commit('SET_CURRENT_MANAGE', currentManage);

      if (initMenu) {
        dispatch(
          'layout/menu/doInitMenu', {
            manageType: currentManage.type,
            doNavigation,
          }, {
            root: true,
          }
        );
      }
    },

    async doChangeManageFromProperty({ dispatch }, { manage } = {}) {
      var currentManage = manage;
       // check if is monoSubproperty
      if (manage.property && manage.property.maxNumSubproperty && manage.property.maxNumSubproperty == 1) {

        // 2. Read the subproperties of property
        const manageInput = new ManageModel(manage).getManageModel()
        const result = await SubpropertyService.list(null, null, 0, 0, manageInput);

        if ( result.count > 0 ) {
          currentManage = {...manage, type: ManageEnum.values.SUBPROPERTY, subproperty: result.rows[0], path: "/subproperty"}
        }
      }

      dispatch('doChangeManage', { manage: currentManage });
    },

    async doBackManage({ getters, dispatch }) {
      let manage = {};

      ProgressBar.start();

      if (getters.currentManage.type == ManageEnum.values.SUBPROGRAM) {
        manage = {
          ...getters.currentManage,
          model: getters.currentManage.program,
          type: ManageEnum.values.PROGRAM,
          path: '/'
        }
      } else if (getters.currentManage.type == ManageEnum.values.PROGRAM) {
        manage = {
          ...getters.currentManage,
          model: getters.currentManage.subproperty,
          type: ManageEnum.values.SUBPROPERTY,
          path: '/subproperty'
        }
      } else if (getters.currentManage.type == ManageEnum.values.SUBPROPERTY) {
        if (getters.isMonoSubproperty){
          manage = {
            ...getters.currentManage,
            model: getters.currentManage.admin,
            type: ManageEnum.values.ADMIN,
            path: '/'
          }
        } else {
          manage = {
            ...getters.currentManage,
            model: getters.currentManage.property,
            type: ManageEnum.values.PROPERTY,
            path: '/property'
          }
        }
      } else if (getters.currentManage.type == ManageEnum.values.PROPERTY) {
        manage = {
          ...getters.currentManage,
          model: getters.currentManage.admin,
          type: ManageEnum.values.ADMIN,
          path: '/'
        }
      }

      dispatch('doChangeManage', { manage, forceFetch: true });
    },
  },
};
